import { assoc } from 'ramda';
import buildROIntervalsWithFranchise from './buildROIntervalsWithFranchise.js';
import {
  buildFranchiseConfig,
  hasSeparateFranchises,
  selectGuaranteesWithNodes,
  buildFranchiseTabs
} from '../hooks/helpers/franchiseHelpers.js';

const buildROIntervalsWithTabsAndFranchise = ({
  guarantees,
  pricesGuarantees,
  getMiddleBoolean,
  configPrefix,
  transformGuarantees = (g) => g,
  franchise = null
}) => {
  const franchiseConfig = buildFranchiseConfig(getMiddleBoolean, configPrefix);
  const guaranteesWithNodes = selectGuaranteesWithNodes(guarantees, pricesGuarantees);
  const transformedGuarantees = transformGuarantees(guaranteesWithNodes);
  const baseROData = buildROIntervalsWithFranchise(transformedGuarantees, franchiseConfig, franchise);

  if (hasSeparateFranchises(franchiseConfig)) {
    const tabs = buildFranchiseTabs(franchiseConfig, baseROData);
    return assoc('tabs', tabs, baseROData);
  }

  return baseROData;
};

export default buildROIntervalsWithTabsAndFranchise;
